import { callAuthorizedGraphQLEndpoint } from '../../Module/graphQL'
import { convertArrayToHashMap } from '../../shared/libraries/dataSets'

/**
 * Fetches clients by chunks while there is a next page using recursion
 * @param {number} params.chunkSize Size of the request
 * @param {number} params.skip Amount of items to skip
 */
export const fetchAllClientsByChunks = async ({
  chunkSize = 100,
  skip = 0,
}) => {
  const gql = `
    query ($first: Int, $skip: Int) {
      clients (first:$first, skip:$skip) {
        pageInfo{
          hasNextPage
        }
        edges {
          node {
            id
            name
          }
        }
      }
      countries {
        nodes {
          id
          name
        }
      }
    }
  `
  const res = await callAuthorizedGraphQLEndpoint(gql, {
    first: chunkSize,
    skip,
  })

  const { data } = await res.json()

  let countriesResult = data.countries.nodes
  let clientsResult = data.clients.edges.map(edge => edge.node)

  // If there's a next page fetch it with skip
  if (data.clients.pageInfo.hasNextPage) {
    const { clients, countries } = await fetchAllClientsByChunks({
      chunkSize,
      skip: chunkSize + skip,
    })
    countriesResult = [...countriesResult, ...countries]
    clientsResult = [...clientsResult, ...clients]
  }
  const uniqueCountries = Object.values(
    convertArrayToHashMap(countriesResult, 'id'),
  )

  return {
    countries: uniqueCountries,
    clients: clientsResult,
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Campaigns/gql.js